import React, { useState, useEffect } from "react";
import solutionIcon from "../../../assets/ambition_icons/solutions-lab-icon.svg";
import "../components/AmbitionIntro/index.css";
import featuredStart from "../../../assets/ambition_icons/featured-star.svg";
import "./SolutionLabIntro.css";
import partnershipService from "../../../apis/Partnerships/partnershipService";

export const SolutionIntro = ({ toggle }) => {
  const [featuredPartnership, setFeaturedPartnership] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedPartnership = async () => {
      try {
        setLoading(true);
        const featuredPartnerships =
          await partnershipService.getFeaturedPartnerships();

        // Get the first featured partnership (or null if none)
        const firstFeatured =
          featuredPartnerships.length > 0 ? featuredPartnerships[0] : null;
        setFeaturedPartnership(firstFeatured);
      } catch (err) {
        console.error("Error fetching featured partnership:", err);
        setError("Failed to load featured partnership");
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedPartnership();
  }, []);

  const getCompanyLogo = (partnership) => {
    if (partnership?.documents && partnership.documents.length > 0) {
      const logoDoc = partnership.documents.find(
        (doc) => doc.document_type === "company_logo"
      );
      return logoDoc
        ? `https://res.cloudinary.com/azilisdjo/${logoDoc.file}`
        : null;
    }
    return null;
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "30.25px",
        paddingTop: "39px",
        marginBottom: "60px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div className="ambition-intro-card-container">
          <h5 style={{ fontWeight: "bold" }}>Solutions Lab</h5>
          <img
            src={solutionIcon}
            alt="Ambition Icon"
            width={70}
            height={70}
            style={{ objectFit: "cover" }}
          />
        </div>
        <button className="solution-lab-btn-publish" onClick={toggle}>
          Want to publish your solution here?
        </button>
        <span
          style={{
            marginTop: "5px",
            fontSize: "10px",
            color: "#18376D",
          }}
        >
          All prices are ex.vat.
        </span>
      </div>

      <div className="ambition-desc-box">
        <h5 className="ambition-desc-box-title " style={{ color: "#193666" }}>
          Solutions Lab
        </h5>
        <p className="ambition-desc-box-text" style={{ color: "#193666" }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>

      {/* Featured Partnership Section - Only show if there's featured data */}
      {!loading && !error && featuredPartnership && (
        <div className="solution-lab-featured-top-bg">
          <div
            style={{ position: "absolute", left: "38%", top: "-20px" }}
            className="solution-lab-featured-logo"
          >
            <img
              src={getCompanyLogo(featuredPartnership) || solutionIcon}
              width={53}
              height={54}
              alt={`${featuredPartnership.company_name} logo`}
              style={{ objectFit: "cover" }}
            />
          </div>
          <div className="solution-lab-featured-title">
            {featuredPartnership.company_name}
          </div>
          <div className="solution-lab-featured-box">
            {featuredPartnership.company_description}
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              marginTop: "10px",
              position: "relative",
            }}
          >
            <img
              src={featuredStart}
              alt="Featured Start"
              width={20}
              height={20}
            />
            <span
              style={{ color: "#09366B", fontSize: "14px", fontWeight: "bold" }}
            >
              Featured Partner
            </span>
          </div>
        </div>
      )}

      {/* Loading state */}
      {loading && (
        <div className="solution-lab-featured-top-bg">
          <div className="solution-lab-featured-title loading">
            Loading featured partner...
          </div>
        </div>
      )}

      {/* Error state */}
      {error && (
        <div className="solution-lab-featured-top-bg">
          <div className="solution-lab-featured-title error">
            Unable to load featured partner
          </div>
        </div>
      )}
    </div>
  );
};
